import {useState,useEffect,useLayoutEffect,React} from 'react';
import {Tabs,Table,Tab,Form,Button,Card,Row,Container,Col} from 'react-bootstrap'
import Swal from 'sweetalert2'
import Axios from 'axios'
import FileInput from './file';
import {ShowMsg} from './pop';
import {Url, UatUrl} from './url';
import FeatherIcon from 'feather-icons-react';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { io } from "socket.io-client";
import Papa from 'papaparse';
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

//console.log("Before Socket connect here!!!");
  var socket;
  var refreshInterval;
function TerminalList(...props){
  const [pos,setPos]=useStateWithCallbackLazy([]);
  const [terminals,setTerminals]=useState([]);
  const [pages,setPages]=useState(0);
  const [rows,setRows] =useState(10);
  const [sdata,setSdata]=useState('');
  const [isFirstTime,setFirsttime]=useState(true);
  const [isOnline,setOnline]=useState(true);
  const [tid,setTid]=useState(0);
  const [cpos,setCPos]=useState({});
  const [isLoading, setLoading] = useState(false);
  var tm ={};

  const LoadingSpinner = () => (
    <div className="text-center p-5">
      <FeatherIcon icon="settings" size="48" className="spin text-info mb-3" />
      <h5 className="text-muted">Fetching terminal data...</h5>
    </div>
  );

  const columns = [
    {
      dataField: 'no',
      text: 'No.',
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      dataField: 'ptid',
      text: 'Terminal ID',
      sort: true,
      filter: textFilter()
    },
    {
      dataField: 'lastupdate',
      text: 'Last Update',
      sort: true,
      filter: textFilter()
    }
  ];

  const getStats = () => {
    let stats = { total: pos.length, downloaded: 0, never: 0 };
    pos.forEach(t => {
      // Corrected logic: a terminal is 'never' if lastupdate is 'Never', empty, or null
      if (!t.lastupdate || t.lastupdate === 'Never' || t.lastupdate.trim() === '') {
        stats.never++;
      } else {
        stats.downloaded++;
      }
    });
    return stats;
  }

  const exportData = (type) => {
    let dataToExport = [];
    if (type === 'all') dataToExport = pos;
    else if (type === 'downloaded') dataToExport = pos.filter(t => t.lastupdate && t.lastupdate !== 'Never' && t.lastupdate.trim() !== '');
    else if (type === 'never') dataToExport = pos.filter(t => !t.lastupdate || t.lastupdate === 'Never' || t.lastupdate.trim() === '');

    if (dataToExport.length === 0) {
      ShowMsg("No records to export", false);
      return;
    }

    const csv = Papa.unparse(dataToExport);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `terminals_${type}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

   const socketClientInit =()=>{

     console.log("Doing Socket Registration!!");
     socket.on('connect',()=>{
       console.log("client connected!! OK");
       socket.emit('joinRoom',{ptid:'tmsportal',roomname:'tms'})
     })





     socket.on('connect_error',()=>{
       console.log("getting a connect error here!!");
       //socket.disconnect()
     })

     socket.on("disconnect", () => {
       console.log("client disconnected here!!");
     console.log(socket.connected); // false
     //socket.connect();
   });
     socket.on('message',(dat)=>{
       console.log('Event=>message: here: '+ JSON.stringify(dat));
        socket.emit("chat",{msg:'online'});
     });

     socket.on('listUpdate',(dat)=>{
       setLoading(false);
       setFirsttime(false);
       console.log('Pos List here: '+ JSON.stringify(dat));
          let tmp =[];
          let days ='';
          while(pos.length){
            pos.pop();
          }
          //setPos([]);
          console.log("pos size: "+pos.length);
       if(dat.length>0){
         for(var i=0; i<dat.length; i++){
           if(dat[i].lastupdate !== ''){
             //process time passed since last update here
             days =getLastupdateNote(dat[i].lastupdate);
             console.log("Last update note: "+days);
           }else{
             days="Never";
           }
         tmp.push({ptid:dat[i].ptid,model:dat[i].model,status:dat[i].status,lastupdate:days});
       }
     }
     if(pos.length)
     console.log("pos[0].ptid: "+ pos[0].lastupdate);
     setPos(tmp,()=>{
       console.log("done assigning: "+pos.model);
     });
     });



     socket.on('chat',(dat)=>{
       console.log('Received response here!!: '+ JSON.stringify(dat));
       const cmd={msg:'online'}
       socket.emit('chat',cmd);
     });



     socket.on('ping',(dat)=>{
        console.log("received ping: "+JSON.stringify(dat));
        pingHandler();
     });
   }

   const getLastupdateNote =(updateDate)=>{

     const oldDate = new Date(updateDate);
     console.log("old date: "+oldDate);
     const now = new Date();
     console.log("Now: "+now);
      var diff = (now-oldDate);
     diff = Math.abs(Math.floor(diff));;
     console.log("time diff: "+diff);

     // math
    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
    if(days>0)
    {
      return days +" days ago";
    }
    let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if(hours>0){
      return hours + "hours ago";
    }
    let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    if(minutes>0){
      return (minutes<2)? minutes + " minute ago":minutes + " minutes ago";
    }
    let seconds = Math.floor((diff % (1000 * 60)) / 1000);
    if(seconds<10){
      return "just now";
    }else if(seconds> 10){
      return "few moments ago";
    }


   }

   const refreshHandler =()=>{
     setLoading(true);
     const cmd={cmd:0x01,ptid:'*'};
    console.log("refresh handler clicked: msg: "+JSON.stringify(cmd));
     socket.emit('ping',cmd,(data)=>{
       console.log("message received after emit: "+data);
       if(!data){
         refresh();
       }
     });
     // Safety timeout to reset loading state
     setTimeout(() => setLoading(false), 5000);
   }

  const findHandler =(e)=>{
    e.preventDefault();
    return;
  }

  const filterHandler =(e)=>{
    const val = e.target.value;
    setSdata(val);
    return;
}

const getLastUpdate=(val)=>{

}

const getStatus= (s)=>{
  if(s === '')
  return 'offline';
  else if(s==='online' || s.startsWith('Download'))
  return 'online';
  else
  return s;

}

const refresh =()=>{
  var url =Url+'/getterminals';
  const data={};
  console.log("Doing Terminal refresh here!!!");
  Axios.post(url,data).then((res)=>{
    console.log('Terminals refresh Response received: '+res.data.msg);
    if(res.data.msg==='ok'){
        console.log('Terminal Export OK!!'+ JSON.stringify(res.data.list));
        setTerminals(res.data.list);
        console.log("terminals size: "+res.data.list.length);
        setPos(res.data.list);
        //const ps =res.data.list;

    }else{
      console.log('Terminal Export failed!!!');
    }
  });

}

const pingHandler = ()=>{
  const cmd ={
   msg:'online'
  };
  console.log("##Data to send: "+JSON.stringify(cmd));
socket.emit('ping',cmd);
}

const updateHandler =(e)=>{
  const id = e.target.id;
  setTid(id);
  const ptid = pos[id].ptid;
  console.log("terminal id: "+id+" ptid: "+ptid);
  const cmd={
    ptid:ptid,
  }
  console.log("Data to send: "+JSON.stringify(cmd));
socket.emit('update',cmd);
}

//TODO: on start
//refresh();
const sockDisconnect =()=>{
  console.log("running socket disconnect here!!");
    //socket.disconnect();
}


useEffect(()=>{
  socket = io(UatUrl);
  socket.open();
  socketClientInit();
    refreshInterval = setInterval(() => {
      socket.emit('ping',{msg:'online'});
    }, 15000);
  return (()=>{closeEvents()});
},[]);

const closeEvents=()=>{
  clearInterval(refreshInterval);
  socket.close();
}


     return(
       <div  className="pb-4 mb-5">
       <Row className="mb-4">
         <Col md={3}>
           <Card className="text-center shadow-sm border-0 bg-white">
             <Card.Body>
               <div className="mb-3 text-primary">
                 <FeatherIcon icon="monitor" size="32" />
               </div>
               <Card.Title className="text-muted small text-uppercase fw-bold">Total Terminals</Card.Title>
               <Card.Text className="h2 mb-3 text-primary">{getStats().total}</Card.Text>
               <Button variant="outline-primary" size="sm" className="rounded-pill" onClick={() => exportData('all')}>
                 <FeatherIcon icon="download" size="14" className="me-1" /> Export All
               </Button>
             </Card.Body>
           </Card>
         </Col>
         <Col md={3}>
           <Card className="text-center shadow-sm border-0 bg-white">
             <Card.Body>
               <div className="mb-3 text-success">
                 <FeatherIcon icon="check-circle" size="32" />
               </div>
               <Card.Title className="text-muted small text-uppercase fw-bold">Downloaded</Card.Title>
               <Card.Text className="h2 mb-3 text-success">{getStats().downloaded}</Card.Text>
               <Button variant="outline-success" size="sm" className="rounded-pill" onClick={() => exportData('downloaded')}>
                 <FeatherIcon icon="download" size="14" className="me-1" /> Export Downloaded
               </Button>
             </Card.Body>
           </Card>
         </Col>
         <Col md={3}>
           <Card className="text-center shadow-sm border-0 bg-white">
             <Card.Body>
               <div className="mb-3 text-danger">
                 <FeatherIcon icon="x-circle" size="32" />
               </div>
               <Card.Title className="text-muted small text-uppercase fw-bold">Never Downloaded</Card.Title>
               <Card.Text className="h2 mb-3 text-danger">{getStats().never}</Card.Text>
               <Button variant="outline-danger" size="sm" className="rounded-pill" onClick={() => exportData('never')}>
                 <FeatherIcon icon="download" size="14" className="me-1" /> Export Never
               </Button>
             </Card.Body>
           </Card>
         </Col>
       </Row>
       <Row>
       <Col  sm={9}>
       <Card>
       <Card.Header><span className="App-header shadow-sm">Registered Terminal List</span></Card.Header>
       <Card.Body>
       <Form >
        {isFirstTime ? (
          <LoadingSpinner />
        ) : (
          <BootstrapTable
            keyField="ptid"
            data={ pos }
            columns={ columns }
            pagination={ paginationFactory({ sizePerPage: 10 }) }
            filter={ filterFactory() }
            striped
            hover
            condensed
          />
        )}
       <Button variant="info" size="sm" onClick={refreshHandler} disabled={isLoading}>
         <FeatherIcon icon="refresh-cw" size="14" className={isLoading ? "spin me-2" : "me-2"} />
         {isLoading ? "Updating..." : "Refresh"}
       </Button>
       </Form>

       </Card.Body>
       </Card>
       </Col>
       </Row>
       </div>
     )
   }


  export default TerminalList;
